import Title2 from "./title2";
import MainFeature from "./mainFeature";

export default function Feature() {
  return (
    <div>
      <Title2 title="Features" />
      <MainFeature />
    </div>
  );
}
